import { gql, useMutation } from "@apollo/client";

const RESET_ADMIN_PASSWORD_MUTATION = gql`
  mutation ResetAdminPassword($_id: ID!, $newPassword: String!, $requesterEmail: String) {
    resetAdminPassword(_id: $_id, newPassword: $newPassword, requesterEmail: $requesterEmail)
  }
`;

export const useResetAdminPasswordMutation = () => {
  const [resetAdminPasswordMutation, { loading, error, data }] = useMutation(
    RESET_ADMIN_PASSWORD_MUTATION
  );

  const resetAdminPassword = async (_id: string, newPassword: string, requesterEmail?: string) => {
    try {
      const { data } = await resetAdminPasswordMutation({
        variables: { _id, newPassword, requesterEmail },
      });
      return data?.resetAdminPassword;
    } catch (error) {
      console.error("Error resetting admin password:", error);
      throw error;
    }
  };

  return { resetAdminPassword, loading, error, data };
};






























